import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/hand-scissors': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M256 480L326 480C331.1 480 336.2 479.4 341.2 478.3L460.2 450.8C490.6 443.8 512 417 512 386.3V180.6C512 156.7 499 134.6 478 122.9L380 68C345.6 48.8 312.7 62.2 287.8 92.8L142.8 37C105 22.4 62.2 40.7 47.2 78.2 32.1 115.9 50.8 158.6 89.2 173.3L168 192 74 182.9C33.2 182.9 0 215.7 0 256 0 296.3 33.2 329.1 74 329.1H161.6C158 355.4 170.3 380.4 192 394.1 178.7 436.7 211 480 256 480zM256 432C230.8 432 230.9 395.4 256 395.4 264.8 395.4 272 388.3 272 379.4V372.6C272 363.7 264.8 356.6 256 356.6H228C202.8 356.6 202.9 320 228 320H256C264.8 320 272 312.8 272 304V297.1C272 288.3 264.8 281.1 256 281.1H74C39.6 281.1 39.6 230.9 74 230.9H256C264.8 230.9 272 223.7 272 214.9V203.2A16-16 0 0 1 261.7 188.3L106.4 128.5C74.8 116.4 93 69.2 125.6 81.8L292.2 145.9A16-16 0 0 1 310.3 141.1L332.1 114.4C337.9 107.3 348.4 105.4 356.6 109.9L454.6 164.8C460.4 168 464 174.1 464 180.6V386.3C464 394.8 458 402.1 449.4 404.1L330.4 431.5A19.7-19.7 0 0 0 326 432H256z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/hand-scissors.js
// module id = BMrx
// module chunks = 144